import { __awaiter, __generator } from "tslib";
import { AdobeAnalyticsUtils, AdobeAnalyticsVersions } from "../../adobeAnalytics";
import AdapterDtm from "./adobeAnalytics/Dtm";
/**
 * AdobeAnalytics
 * Knows how to resolve the current Adobe Analytics implementation of the
 * website and selects the related adapter to process the tracking
 */
var AdobeAnalytics = /** @class */ (function () {
    function AdobeAnalytics(config) {
        var _this = this;
        this.getAdapter = function () {
            if (!_this.adapterReady) {
                _this.adapterReady = new Promise(function (resolver, rejector) {
                    _this.adapterResolver = resolver;
                    _this.adapterRejector = rejector;
                });
                AdobeAnalyticsUtils.resolveAnalyticsVersionWhenReady()
                    .then(function (version) {
                    _this.adapter = _this.adapterFactory(version);
                    _this.adapterResolver(_this.adapter);
                })
                    .catch(_this.adapterRejector);
            }
            return _this.adapterReady;
        };
        this.dtmConfig = config.dtmConfig;
    }
    AdobeAnalytics.prototype.record = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            var adapter;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAdapter()];
                    case 1:
                        adapter = _a.sent();
                        if (adapter) {
                            return [2 /*return*/, this.adapter.record(request)];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AdobeAnalytics.prototype.getName = function () {
        return __awaiter(this, void 0, void 0, function () {
            var adapter;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAdapter()];
                    case 1:
                        adapter = _a.sent();
                        return [2 /*return*/, adapter ? adapter.getName() : "AdobeAnalytics::unresolvable"];
                }
            });
        });
    };
    AdobeAnalytics.prototype.getClient = function () {
        return __awaiter(this, void 0, void 0, function () {
            var adapter;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAdapter()];
                    case 1:
                        adapter = _a.sent();
                        return [2 /*return*/, adapter === null || adapter === void 0 ? void 0 : adapter.getClient()];
                }
            });
        });
    };
    AdobeAnalytics.prototype.adapterFactory = function (version) {
        switch (version) {
            case AdobeAnalyticsVersions.DynamicTagManagement:
                return new AdapterDtm(this.dtmConfig);
            default:
                return null;
        }
    };
    return AdobeAnalytics;
}());
export default AdobeAnalytics;
//# sourceMappingURL=AdobeAnalytics.js.map